export const containsValue = (enumObject, enumValue) => {
    return Object.keys(enumObject).includes(enumValue);
};
